module.exports = __webpack_public_path__ + "img/khoi-10.02f92a83.svg";